var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgExpand(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 14,
    viewBox: "0 0 15 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Expand",
    clipPath: "url(#clip0_23_1727)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M5.59986 4.40419C5.8287 4.61542 5.8287 4.9579 5.59986 5.1691C5.48546 5.27474 5.33552 5.32752 5.18555 5.32752C5.03558 5.32752 4.88563 5.27474 4.77123 5.16913L1.17188 1.84665V3.97536C1.17188 4.27408 0.909551 4.51623 0.585938 4.51623C0.262324 4.51623 0 4.27408 0 3.97536V1.6226C0 0.727897 0.788555 0 1.75781 0H4.30664C4.63025 0 4.89258 0.242145 4.89258 0.540865C4.89258 0.839585 4.63025 1.08173 4.30664 1.08173H2.00054L5.59986 4.40419ZM4.77123 8.67702L1.17188 11.9995V9.87079C1.17188 9.57207 0.909551 9.32993 0.585938 9.32993C0.262324 9.32993 0 9.57207 0 9.87079V12.2236C0 13.1183 0.788555 13.8462 1.75781 13.8462H4.30664C4.63025 13.8462 4.89258 13.604 4.89258 13.3053C4.89258 13.0066 4.63025 12.7644 4.30664 12.7644H2.00054L5.59986 9.44197C5.8287 9.23073 5.8287 8.88826 5.59986 8.67705C5.37103 8.46584 5.00004 8.46581 4.77123 8.67702ZM14.4141 9.32993C14.0904 9.32993 13.8281 9.57207 13.8281 9.87079V11.9995L10.2288 8.67702C9.99993 8.46579 9.62895 8.46579 9.40014 8.67702C9.17133 8.88826 9.1713 9.23073 9.40014 9.44194L12.9995 12.7644H10.6934C10.3697 12.7644 10.1074 13.0066 10.1074 13.3053C10.1074 13.604 10.3697 13.8462 10.6934 13.8462H13.2422C14.2114 13.8462 15 13.1183 15 12.2236V9.87079C15 9.57207 14.7377 9.32993 14.4141 9.32993ZM13.2422 0H10.6934C10.3697 0 10.1074 0.242145 10.1074 0.540865C10.1074 0.839585 10.3697 1.08173 10.6934 1.08173H12.9995L9.40014 4.40419C9.1713 4.61542 9.1713 4.9579 9.40014 5.1691C9.51454 5.27474 9.66448 5.32752 9.81445 5.32752C9.96442 5.32752 10.1144 5.27474 10.2288 5.16913L13.8281 1.84665V3.97536C13.8281 4.27408 14.0904 4.51623 14.4141 4.51623C14.7377 4.51623 15 4.27408 15 3.97536V1.6226C15 0.727897 14.2114 0 13.2422 0Z",
    fill: "url(#paint0_linear_23_1727)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_23_1727",
    x1: 0,
    y1: 6.92308,
    x2: 15,
    y2: 6.92308,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00F2FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.021,
    stopColor: "#03EFFE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.293,
    stopColor: "#24D2FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.554,
    stopColor: "#3CBDFE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.796,
    stopColor: "#4AB0FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4FACFE"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_23_1727"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 15,
    height: 13.8462,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgExpand);
export default __webpack_public_path__ + "static/media/Expand.8722b0d6f805a8576cab43c5b409c647.svg";
export { ForwardRef as ReactComponent };